import React, {useContext, useMemo} from "react";
import {FabekeDropdown} from "./FabekeDropdown";
import {useTextDomainContext} from "../../providers";
import PropTypes from "prop-types";
import {AutocompleteDropdown} from "./AutocompleteDropdown";
import {SimpleDropdown} from "./SimpleDropdown";
import {useRolesList} from "../../../hooks";

/**
 * Customer dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export const RolesDropdownCommon = (props) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { rolesList: options } = useRolesList();

  //#region useMemo
  const dropdownProps = useMemo(() => {
    const ddProps = {
      options,
      componentLabel: gettext("Roles"),
      defaultValue: "",
      visualStyle: "autoComplete",
      size: "small",
    };

    if (props.componentLabel) {
      ddProps.componentLabel = props.componentLabel;
    }

    if (props.defaultValue) {
      ddProps.defaultValue = props.defaultValue;
    }

    if (props.required) {
      ddProps.required = props.required;
    }

    return ddProps;
  }, [
    gettext,
    options,
    props.componentLabel,
    props.defaultValue,
    props.required,
  ]);
  //#endregion useMemo

  //#region Handlers
  /**
   * Handles change event of the partner dropdown
   * @param {object} event event object
   * @returns {void}
   */
  const handleChange = (event) => {
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
  };
  //#endregion Handlers

  return (
    <>
      {props.visualStyle === "autoComplete" && (
        <AutocompleteDropdown onChange={handleChange} {...dropdownProps} />
      )}

      {props.visualStyle === "simple" && (
        <SimpleDropdown onChange={handleChange} {...dropdownProps} />
      )}

      {props.visualStyle === "old" && (
        <FabekeDropdown onChange={handleChange} {...dropdownProps} />
      )}
    </>
  );
};

RolesDropdownCommon.propTypes = {
  componentLabel: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  visualStyle: PropTypes.oneOf(["simple", "old", "autoComplete"]).isRequired,
};
